module.exports = __webpack_public_path__ + "3e9b4f463dc05626dd9f221ca663f5a0.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/edh-logo.svg
// module id = 985
// module chunks = 0